export const AI_TRIAGE_HOME_HOST_ID = "ai-triage-card-host";
export const ALPINE_INIT_EVENT = "alpine:init";
export const MAX_ALPINE_PACK_WAIT_ATTEMPTS = 1;

export function shouldWaitForAiTriageHomePack(
  hostPresent,
  packReady,
  attemptsMade,
  maxAttempts = MAX_ALPINE_PACK_WAIT_ATTEMPTS
) {
  return Boolean(hostPresent) && !packReady && attemptsMade < maxAttempts;
}

export function shouldLoadAiTriageHome(root = document) {
  return Boolean(root.getElementById?.(AI_TRIAGE_HOME_HOST_ID));
}

export function exposeAiTriageHome(factory, target = window) {
  target.aiTriageHome = factory;
}

export function registerAiTriageHomeIfPresent(register, alpine) {
  if (!alpine || typeof register !== "function") {
    return false;
  }
  register(alpine);
  return true;
}

export function bindAiTriageHomeAlpineInit(
  register,
  root = document,
  alpineWindow = window
) {
  root.addEventListener(ALPINE_INIT_EVENT, () => {
    registerAiTriageHomeIfPresent(register, alpineWindow.Alpine);
  });
}

export function initUnstartedAiTriageHomeHost(alpine, root = document) {
  const host = root.getElementById?.(AI_TRIAGE_HOME_HOST_ID);
  if (!host || typeof alpine?.initTree !== "function") {
    return false;
  }
  if (Object.prototype.hasOwnProperty.call(host, "_x_dataStack")) {
    return false;
  }
  alpine.initTree(host);
  return true;
}

export function bootAiTriageHome(
  register,
  factory,
  { alpine = window.Alpine, target = window, root = document } = {}
) {
  exposeAiTriageHome(factory, target);
  bindAiTriageHomeAlpineInit(register, root, target);
  const registered = registerAiTriageHomeIfPresent(register, alpine);
  if (registered) {
    initUnstartedAiTriageHomeHost(alpine, root);
  }
  return registered;
}
